// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"fbff744d","773":"5d740f94"}[chunkId] + ".chunk.js";
};